import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getConsentPrefs, setConsentPrefs, OPEN_CONSENT_EVENT } from '../utils/consent';
import { isMetaPixelConfigured } from '../utils/metaPixel';
import './ConsentManager.css';

/**
 * Cookie banner. Analytics and advertising are separate, opt-in choices with "Essential only"
 * as prominent as accepting. The advertising choice (Meta Pixel) only appears when a pixel is
 * configured for this build and host; visitors who chose before it existed are asked once more.
 */
const ConsentManager = () => {
  const [open, setOpen] = useState(false);
  const [adsAvailable, setAdsAvailable] = useState(false);

  useEffect(() => {
    const ads = isMetaPixelConfigured();
    setAdsAvailable(ads);
    const saved = getConsentPrefs();
    if (saved.setAt == null || (ads && !saved.adChoiceAt)) setOpen(true);
    const reopen = () => {
      setAdsAvailable(isMetaPixelConfigured());
      setOpen(true);
    };
    window.addEventListener(OPEN_CONSENT_EVENT, reopen);
    return () => window.removeEventListener(OPEN_CONSENT_EVENT, reopen);
  }, []);

  const choose = (analytics, marketing) => {
    setConsentPrefs({
      analytics,
      functional: analytics,
      marketing: adsAvailable ? marketing : false,
      ...(adsAvailable ? { adChoiceAt: new Date().toISOString() } : {}),
    });
    setOpen(false);
  };

  if (!open) return null;

  return (
    <section className="zr zr-consent" aria-labelledby="zr-consent-title">
      <div className="zr-consent-head">
        <span className="zr-consent-ico" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20.5 12.5a8.5 8.5 0 1 1-9-9 3 3 0 0 0 4 3.5 3 3 0 0 0 5 5.5z" />
            <path d="M8.5 9.5h.01M15 15h.01M10 15.5h.01M12 11.5h.01" />
          </svg>
        </span>
        <h2 id="zr-consent-title">Cookies, your choice</h2>
      </div>
      {adsAvailable ? (
        <p>
          Essential cookies run the site. With your OK, we also use analytics, and Meta advertising cookies to
          measure our Facebook and Instagram ads. Change this any time in Cookie settings. <Link to="/cookies">Cookie policy</Link>
        </p>
      ) : (
        <p>
          We use essential cookies to make the site work. With your OK, we also use analytics to see what helps.
          Change this any time in Cookie settings. <Link to="/cookies">Cookie policy</Link>
        </p>
      )}
      <div className={`zr-consent-actions${adsAvailable ? " is-three" : ""}`}>
        <button type="button" onClick={() => choose(false, false)}>Essential only</button>
        {adsAvailable ? (
          <>
            <button type="button" onClick={() => choose(true, false)}>Analytics only</button>
            <button type="button" className="is-accept" onClick={() => choose(true, true)}>Accept all</button>
          </>
        ) : (
          <button type="button" className="is-accept" onClick={() => choose(true, false)}>Accept analytics</button>
        )}
      </div>
    </section>
  );
};

export default ConsentManager;
